import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dHeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular$dCallback from "../Specular.Callback/index.js";
import * as Specular$dDom$dBrowser from "../Specular.Dom.Browser/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dBuilder$dClass from "../Specular.Dom.Builder.Class/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidgets$dInput from "../Specular.Dom.Widgets.Input/index.js";
import * as Specular$dDom$dWidgets$dRadioGroup from "../Specular.Dom.Widgets.RadioGroup/index.js";
import * as Specular$dFRP$dAsync from "../Specular.FRP.Async/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Utils$dDynamicFixFRP from "../Utils.DynamicFixFRP/index.js";
const $ErrorContent = (tag, _1) => ({tag, _1});
const $ValidationState = (tag, _1) => ({tag, _1});
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const domEvent = /* #__PURE__ */ Specular$dDom$dBuilder$dClass.domEventWithSample(monadFRP)(v => () => {});
const subscribeEvent_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeNode(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dDom$dBuilder.monadCleanupBuilder);
const dynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.dynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const uniqDyn = /* #__PURE__ */ (() => {
  const uniqDynBy1 = Specular$dFRP$dBase.uniqDynBy(monadFRP);
  return dictEq => uniqDynBy1(dictEq.eq);
})();
const holdUniqDynBy = /* #__PURE__ */ Specular$dFRP$dBase.holdUniqDynBy(monadFRP);
const identity = x => x;
const asyncRequest = /* #__PURE__ */ Specular$dFRP$dAsync.asyncRequest(Specular$dInternal$dRIO.monadEffectRIO)(monadFRP);
const dynamicFixFRP = /* #__PURE__ */ (() => Utils$dDynamicFixFRP.dynamicFixFRPDynamic.dynamicFixFRP(monadFRP))();
const newRef = /* #__PURE__ */ Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO);
const monadWidget = /* #__PURE__ */ (() => {
  const $0 = Specular$dDom$dBuilder.monoidBuilder(Data$dMonoid.monoidUnit);
  return {
    MonadDomBuilder0: () => Specular$dDom$dBuilder.monadDomBuilderBuilder,
    MonadFRP1: () => monadFRP,
    MonadReplace2: () => Specular$dDom$dBuilder.monadReplaceBuilder,
    Monoid3: () => $0
  };
})();
const radioGroup = /* #__PURE__ */ Specular$dDom$dWidgets$dRadioGroup.radioGroup(monadWidget);
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Specular$dInternal$dRIO.applicativeRIO)(Data$dFoldable.foldableArray);
const booleanInputView = /* #__PURE__ */ Specular$dDom$dWidgets$dInput.booleanInputView(monadWidget);
const attachEvent = /* #__PURE__ */ Specular$dCallback.attachEvent()(monadFRP);
const $$new = /* #__PURE__ */ Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO);
const textInput = /* #__PURE__ */ Specular$dDom$dWidgets$dInput.textInput(monadWidget);
const textInputValueOnChange = /* #__PURE__ */ Specular$dDom$dWidgets$dInput.textInputValueOnChange(monadFRP);
const wrapViewWidget = /* #__PURE__ */ Specular$dRef.wrapViewWidget(monadWidget);
const checkboxView = /* #__PURE__ */ Specular$dDom$dWidgets$dInput.booleanInputView(monadWidget)(Specular$dDom$dWidgets$dInput.Checkbox);
const checkbox = /* #__PURE__ */ Specular$dDom$dWidgets$dInput.checkbox(monadWidget);
const NotChanged = /* #__PURE__ */ $ValidationState("NotChanged");
const Loading = /* #__PURE__ */ $ValidationState("Loading");
const Success = /* #__PURE__ */ $ValidationState("Success");
const $$Error = value0 => $ValidationState("Error", value0);
const ErrorText = value0 => $ErrorContent("ErrorText", value0);
const ErrorRawHtml = value0 => $ErrorContent("ErrorRawHtml", value0);
const textInputOnTouch = initialValue => attributes => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBuilder.monadDomBuilderBuilder["elDynAttrNS'"](Data$dMaybe.Nothing)("input")(Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(attributes))(Restaumatic$dPrelude$dSpecular.wempty))(v => {
  const $0 = v._1;
  return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dWidgets$dInput.setTextInputValue($0)(initialValue))(() => Specular$dInternal$dRIO.bindImpl(domEvent("input")($0))(domChanged => Specular$dInternal$dRIO.bindImpl(subscribeEvent_(v1 => Specular$dDom$dWidgets$dInput.setTextInputValue($0)(initialValue))(domChanged))(() => Specular$dInternal$dRIO.pureImpl({
    value: (() => {
      const n = Specular$dInternal$dIncremental.constant(initialValue);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })(),
    event: domChanged
  }))));
});
const renderErrorString = {renderError: Specular$dDom$dElement.text};
const renderErrorErrorContent = {
  renderError: v => {
    if (v.tag === "ErrorText") { return Specular$dDom$dElement.text(v._1); }
    if (v.tag === "ErrorRawHtml") {
      const $0 = v._1;
      return Specular$dInternal$dRIO.rio(env => Specular$dDom$dBrowser.appendRawHtmlImpl($0)(env.parent));
    }
    $runtime.fail();
  }
};
const renderError = dict => dict.renderError;
const validationInfo = dictRenderError => validationState => Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("m-form__validation-info")])(dynamic_(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v.tag === "NotChanged") { return Restaumatic$dPrelude$dSpecular.wempty; }
  if (v.tag === "Loading") { return Restaumatic$dPrelude$dSpecular.wempty; }
  if (v.tag === "Success") { return Restaumatic$dPrelude$dSpecular.wempty; }
  if (v.tag === "Error") { return dictRenderError.renderError(v._1); }
  $runtime.fail();
})(validationState)));
const formGroupClass = state => Specular$dDom$dElement.classesD(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v.tag === "NotChanged") { return []; }
  if (v.tag === "Loading") { return ["is-loading"]; }
  if (v.tag === "Success") { return ["success"]; }
  if (v.tag === "Error") { return ["has-error"]; }
  $runtime.fail();
})(state));
const group = validationState => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("form-group m-form__group"), formGroupClass(validationState)]);
const fieldWithValidation = () => dictEq => {
  const uniqDyn1 = uniqDyn(dictEq);
  return validate => view => dynamicFixFRP(NotChanged)(a => Specular$dInternal$dRIO.bindImpl(view(a))(valueR => Specular$dInternal$dRIO.bindImpl(uniqDyn1(valueR.value))(valueD => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(v => v.forceShowValidationErrors)(Specular$dDom$dBuilder.monadAskBuilder.ask))(forceShowErrors => Specular$dInternal$dRIO.bindImpl(holdUniqDynBy(Data$dEq.eqBooleanImpl)(false)(Specular$dFRP$dBase.leftmost([
    Specular$dFRP$dBase.functorEvent.map(v => true)(valueD),
    Specular$dFRP$dBase.filterEvent(identity)(forceShowErrors)
  ])))(hasChanged => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(Specular$dFRP$dBase.functorDynamic.map(v => {
    if (v.tag === "Loaded") { return v._1; }
    if (v.tag === "Loading") { return Loading; }
    if (v.tag === "NotRequested") { return NotChanged; }
    $runtime.fail();
  }))(asyncRequest(Specular$dFRP$dBase.functorDynamic.map(validate)(valueR.value))))(validationState => Specular$dInternal$dRIO.pureImpl(Data$dTuple.$Tuple(
    Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v => v1 => {
      if (v) { return v1; }
      return NotChanged;
    })(hasChanged))(validationState),
    {
      ...Record$dUnsafe.unsafeDelete("value")(valueR),
      valid: Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(state => value$p => {
        if (state.tag === "Success") { return Data$dMaybe.$Maybe("Just", value$p); }
        return Data$dMaybe.Nothing;
      })(validationState))(valueR.value),
      raw: valueR.value
    }
  ))))))));
};
const eqValidationState = dictEq => (
  {
    eq: x => y => {
      if (x.tag === "NotChanged") { return y.tag === "NotChanged"; }
      if (x.tag === "Loading") { return y.tag === "Loading"; }
      if (x.tag === "Success") { return y.tag === "Success"; }
      if (x.tag === "Error") {
        if (y.tag === "Error") { return dictEq.eq(x._1)(y._1); }
        return false;
      }
      return false;
    }
  }
);
const controlLabel = opts => Specular$dDom$dElement.el("label")([
  Specular$dDom$dElement.class_("control-label m-form__label"),
  opts.required ? Specular$dDom$dElement.class_("m-form__label--required") : Specular$dDom$dElement.monoidProp.mempty,
  Specular$dDom$dElement.attr("for")(opts.for)
]);
const radioGroupField = dictEq => config => Specular$dInternal$dRIO.bindImpl(newRef(Data$dMaybe.Nothing))(selectedRef => Specular$dDom$dElement.el("div")([
  Specular$dDom$dElement.class_("radio_buttons input form-group"),
  config.required ? Specular$dDom$dElement.class_("required") : Specular$dDom$dElement.monoidProp.mempty
])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("form-label")])(controlLabel({required: config.required, for: ""})(Specular$dDom$dElement.text(config.label))))(() => radioGroup({
  options: config.options,
  initialValueIndex: (() => {
    const $0 = Data$dArray.findIndexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, dictEq.eq(config.initial), config.options);
    if ($0.tag === "Nothing") { return 0; }
    if ($0.tag === "Just") { return $0._1; }
    $runtime.fail();
  })(),
  render: id => option => radio => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("radio")])(Specular$dDom$dElement.el("label")([
    Specular$dDom$dElement.attr("for")(id),
    Specular$dDom$dElement.class_("choice m-radio")
  ])(Specular$dInternal$dRIO.bindImpl(radio(Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $0 = {};
    $0.class = "m-radio__input";
    return $0;
  })())((() => {
    const $0 = config.testId(option);
    return (() => {
      const $1 = {};
      $1["data-testid"] = $0;
      return $1;
    })();
  })()))))(value => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("i")([Specular$dDom$dElement.class_("m-radio__icon-state")])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(config.display(option)(selectedRef))(() => Specular$dInternal$dRIO.pureImpl(value))))))
}))));
const radioGroupFieldInitiallyEmpty = dictEq => config => fieldName => errorMessage => Specular$dInternal$dRIO.bindImpl(newRef(config.initial))(selectedOption => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(v => v.forceShowValidationErrors)(Specular$dDom$dBuilder.monadAskBuilder.ask))(forceShowErrors => {
  const showError = Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Data$dHeytingAlgebra.boolConj)(forceShowErrors))(Specular$dFRP$dBase.functorDynamic.map(x => {
    if (x.tag === "Nothing") { return config.required; }
    if (x.tag === "Just") { return false; }
    $runtime.fail();
  })(selectedOption._1));
  return Specular$dInternal$dRIO.bindImpl((() => {
    const $0 = Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.class_("radio_buttons input form-group"),
      config.required ? Specular$dDom$dElement.class_("required") : Specular$dDom$dElement.monoidProp.mempty,
      Specular$dDom$dElement.classWhenD(showError)("has-error")
    ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("form-label")])(controlLabel({required: config.required, for: ""})(Specular$dDom$dElement.text(config.label))))(() => Specular$dInternal$dRIO.bindImpl(for_(config.options)(option => Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.class_("radio")
    ])(Specular$dDom$dElement.el("label")([Specular$dDom$dElement.class_("choice m-radio")])(Specular$dInternal$dRIO.bindImpl(booleanInputView(Specular$dDom$dWidgets$dInput.Radio)(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(Specular$dFRP$dBase.functorDynamic.map(y => {
      if (y.tag === "Just") { return dictEq.eq(option)(y._1); }
      return false;
    })(selectedOption._1)))(Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $0 = {};
      $0.name = fieldName;
      return $0;
    })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $0 = {};
      $0.class = "m-radio__input";
      return $0;
    })())((() => {
      const $0 = config.testId(option);
      return (() => {
        const $1 = {};
        $1["data-testid"] = $0;
        return $1;
      })();
    })())))))(selectionChanged => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("i")([Specular$dDom$dElement.class_("m-radio__icon-state")])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(config.display(option)(selectedOption))(() => attachEvent(Specular$dFRP$dBase.functorEvent.map(v => Data$dMaybe.$Maybe(
      "Just",
      option
    ))(Specular$dFRP$dBase.filterEvent(identity)(selectionChanged)))(x => selectedOption._2(_old => x)))))))))(() => validationInfo(renderErrorString)(Specular$dFRP$dBase.functorDynamic.map(showError$p => {
      if (showError$p) { return $ValidationState("Error", errorMessage); }
      return NotChanged;
    })(showError)))));
    return env => {
      const $1 = {...env, userEnv: undefined};
      return $0($1);
    };
  })())(() => Specular$dInternal$dRIO.pureImpl(selectedOption._1));
}));
const textField = dictRenderError => v => {
  const $0 = v.attrs;
  const $1 = v.autoFormat;
  const $2 = v.initialValue;
  const $3 = v.name;
  const $4 = v.validationState;
  return group($4)(Specular$dInternal$dRIO.bindImpl(controlLabel({required: v.required, for: $3})(Specular$dDom$dElement.text(v.label)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl((() => {
    if ($1.tag === "Nothing") { return x => x; }
    if ($1.tag === "Just") { return Specular$dRef.invariantRef.imap($1._1)($1._1); }
    $runtime.fail();
  })())($$new($2)))(valueRef => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("input")([
    Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $5 = {};
      $5.id = $3;
      return $5;
    })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $5 = {};
      $5.class = "form-control u-text-normal";
      return $5;
    })())($0))),
    Specular$dDom$dElement.bindValueOnChange(valueRef)
  ])(Restaumatic$dPrelude$dSpecular.wempty))(() => {
    const value = valueRef._1;
    return Specular$dInternal$dRIO.bindImpl(validationInfo(dictRenderError)($4))(() => Specular$dInternal$dRIO.pureImpl({value}));
  }))));
};
const textField$p = dictRenderError => v => newValue => {
  const $0 = v.attrs;
  const $1 = v.initialValue;
  const $2 = v.name;
  const $3 = v.validationState;
  return group($3)(Specular$dInternal$dRIO.bindImpl(controlLabel({required: v.required, for: $2})(Specular$dDom$dElement.text(v.label)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.bindImpl(textInput({
    initialValue: $1,
    attributes: Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $4 = {};
      $4.id = $2;
      return $4;
    })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $4 = {};
      $4.class = "form-control u-text-normal";
      return $4;
    })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $4 = {};
      $4.name = $2;
      return $4;
    })())($0)))),
    setValue: newValue
  }))(input => textInputValueOnChange(input)))(value => Specular$dInternal$dRIO.bindImpl(validationInfo(dictRenderError)($3))(() => Specular$dInternal$dRIO.pureImpl({value})))));
};
const textFieldLock = dictRenderError => v => {
  const $0 = v.attrs;
  const $1 = v.initialValue;
  const $2 = v.name;
  const $3 = v.validationState;
  return group($3)(Specular$dInternal$dRIO.bindImpl(controlLabel({required: v.required, for: $2})(Specular$dDom$dElement.text(v.label)))(() => Specular$dInternal$dRIO.bindImpl(textInputOnTouch($1)(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $4 = {};
    $4.id = $2;
    return $4;
  })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $4 = {};
    $4.class = "form-control u-text-normal";
    return $4;
  })())($0))))(v1 => {
    const $4 = v1.event;
    const $5 = v1.value;
    return Specular$dInternal$dRIO.bindImpl(validationInfo(dictRenderError)($3))(() => Specular$dInternal$dRIO.pureImpl({value: $5, event: $4}));
  })));
};
const checkboxFieldRef = dictRenderError => v => {
  const $0 = v.attrs;
  const $1 = v.label;
  const $2 = v.validationState;
  return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("boolean input checkbox form-group"), formGroupClass($2)])(Specular$dDom$dElement.el("span")([
    Specular$dDom$dElement.class_("form-wrapper")
  ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("label")([
    Specular$dDom$dElement.class_("m-checkbox"),
    v.required ? Specular$dDom$dElement.class_("m-form__label--required") : Specular$dDom$dElement.monoidProp.mempty
  ])(Specular$dInternal$dRIO.bindImpl(wrapViewWidget(x => checkboxView(x)(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.functorMaybe.map(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $3 = {};
    $3.class = "m-checkbox__input";
    return $3;
  })())))(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)($0))))(v.value))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("i")([
    Specular$dDom$dElement.class_("m-checkbox__icon-state")
  ])(Restaumatic$dPrelude$dSpecular.wempty))(() => $1))))(() => validationInfo(dictRenderError)($2))));
};
const checkboxField = dictRenderError => v => {
  const $0 = v.label;
  const $1 = v.validationState;
  return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("boolean input checkbox form-group"), formGroupClass($1)])(Specular$dDom$dElement.el("span")([
    Specular$dDom$dElement.class_("form-wrapper")
  ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("label")([
    Specular$dDom$dElement.class_("m-checkbox"),
    v.required ? Specular$dDom$dElement.class_("m-form__label--required") : Specular$dDom$dElement.monoidProp.mempty
  ])(Specular$dInternal$dRIO.bindImpl(checkbox(v.initialValue)(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $2 = {};
    $2.class = "m-checkbox__input";
    return $2;
  })())(v.attrs)))(value => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("i")([Specular$dDom$dElement.class_("m-checkbox__icon-state")])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl($0)(() => Specular$dInternal$dRIO.pureImpl(value))))))(value => Specular$dInternal$dRIO.bindImpl(validationInfo(dictRenderError)($1))(() => Specular$dInternal$dRIO.pureImpl({
    value
  })))));
};
export {
  $ErrorContent,
  $ValidationState,
  $$Error as Error,
  ErrorRawHtml,
  ErrorText,
  Loading,
  NotChanged,
  Success,
  asyncRequest,
  attachEvent,
  booleanInputView,
  checkbox,
  checkboxField,
  checkboxFieldRef,
  checkboxView,
  controlLabel,
  domEvent,
  dynamicFixFRP,
  dynamic_,
  eqValidationState,
  fieldWithValidation,
  for_,
  formGroupClass,
  group,
  holdUniqDynBy,
  identity,
  monadFRP,
  monadWidget,
  $$new as new,
  newRef,
  radioGroup,
  radioGroupField,
  radioGroupFieldInitiallyEmpty,
  renderError,
  renderErrorErrorContent,
  renderErrorString,
  subscribeEvent_,
  textField,
  textField$p,
  textFieldLock,
  textInput,
  textInputOnTouch,
  textInputValueOnChange,
  uniqDyn,
  validationInfo,
  wrapViewWidget
};
